<template>
  <div id="app">
    <v-app>
      <v-toolbar :color="mainColor" dark fixed height="73">
        <v-toolbar-side-icon
          class="hidden-md-and-up"
          @click.stop="showDrawer = !showDrawer"
        ></v-toolbar-side-icon>

        <v-img
          :src="require('@/assets/ESD-new-logo-a.png')"
          @click="routeHome"
          height="45px"
          width="195px"
          contain
          :class="$vuetify.breakpoint.xs ? 'logoSm' : 'logo'"
          id="logo"
          aspect-ratio="1"
        ></v-img>
        <v-spacer></v-spacer>
        <v-toolbar-items
          class="hidden-sm-and-down"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <template v-for="link in links">
            <v-btn
              class="navbarButton"
              flat
              :key="link.name"
              :to="link.route"
              >{{ link.name }}</v-btn
            >
          </template>
          <!-- <v-btn class="navbarButton" flat @click="showStartMsg"
            >START APPLICATION</v-btn
          > -->
        </v-toolbar-items>
      </v-toolbar>
      <v-navigation-drawer
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="showDrawer"
        app
        fixed
        class="navDrawer"
      >
        <v-list>
          <template v-for="link in links">
            <v-subheader :key="link.name">
              <router-link
                :to="link.route"
                class="navDrawer"
                :style="{ color: mainColor }"
                >{{ link.name }}</router-link
              >
            </v-subheader>
          </template>
          <!-- <v-subheader>
            <span :style="{ color: mainColor }" @click="showStartMsg"
              >START APPLICATION</span
            >
          </v-subheader> -->
        </v-list>
      </v-navigation-drawer>
      <router-view
        class="content"
        :routeName="this.$router.currentRoute.name"
        :mainColor="this.mainColor"
        :entity="this.entity"
        :company="this.company"
        style="margin-top: 50px"
      />
      <v-dialog v-model="startMsg" width="500" v-if="startMsg == true">
        <v-card color="white">
          <v-toolbar :color="mainColor" dark style="padding: 10px">
            <v-card-title class="headline" primary-title style="color: white">
              <v-layout justify-center align-content-center
                >Enrollment Begins 11/1/2020</v-layout
              >
            </v-card-title>
          </v-toolbar>
          <v-card-text style="padding-left: 20px; padding-right: 20px">
            <br />Please return here on or after 11/1/2020 to enroll.
            <br />
            <br />If you would like more information, please contact us at
            <a href="mailto:ESD_SofNM@globe.life" style="text-decoration: none"
              >ESD_SofNM@globe.life</a
            >.
            <br />
          </v-card-text>
          <br />
          <br />
        </v-card>
      </v-dialog>
      <v-footer height="auto" :color="mainColor" fixed>
        <v-flex
          text-xs-center
          white--text
          xs12
          style="padding-left: 20px; padding-right: 20px; padding-top: 5px"
        >
          <v-layout column v-if="$vuetify.breakpoint.smAndDown">
            <span>
              Contact us at&nbsp;
              <a
                href="mailto:ESD_SofNM@globe.life"
                style="color: white; text-decoration: none"
                >ESD_SofNM@globe.life</a
              >&nbsp;to learn more.
            </span>
            <span>
              <a @click="showVideo" style="color: white"
                >CLICK HERE for a product presentation</a
              >
            </span>
            <span>&copy;2020 — Globe Life Employee Services Division</span>
          </v-layout>
          <v-layout align-content-center align-center justify-center row v-else>
            Contact us at&nbsp;
            <a
              href="mailto:ESD_SofNM@globe.life"
              style="color: white; text-decoration: none"
              >ESD_SofNM@globe.life</a
            >&nbsp;to learn more.
            <v-spacer></v-spacer>
            <a @click="showVideo" style="color: white"
              >CLICK HERE for a product presentation</a
            >
            <v-spacer></v-spacer>&copy;2020 — Globe Life Employee Services
            Division
          </v-layout>
        </v-flex>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import store from './store'
import { AWS_HTTP } from './http-common.js'
import { log } from './http-common.js'

export default {
  created: function () {
    let entityInfo = {
      agentName: 'Tom Gomez',
      agentNumber: 'D0190',
      agentPhone: '303-717-8122',
      entityDept: '99999',
    }

    store.commit('setEntityInfo', entityInfo)

    AWS_HTTP.get('agent')
      .then((results) => {
        if (results.status == 200 && results.data) {
          entityInfo.agentName = results.data.agentName
          entityInfo.agentNumber = results.data.agentNumber
          entityInfo.agentNumberAlt = results.data.agentNumberAlt
          entityInfo.agentPhone = results.data.agentPhone

          // console.log(entityInfo)

          store.commit('setEntityInfo', entityInfo)
        }
      })
      .catch((e) => {
        log(e.toString(), true, 'App.vue created')
      })
  },
  data: function () {
    return {
      links: [
        { name: 'HOME', route: '/' },
        { name: 'ABOUT US', route: '/about' },
        { name: 'OUR PRODUCTS', route: '/products' },
        { name: 'START APPLICATION', route: '/application' },
      ],
      showDrawer: false,
      startMsg: false,

      //mainColor: '#03558b',
      mainColor: '#00558C',

      // TO DO: Pull this from...URL?
      entity: {
        name: 'State of New Mexico',
        id: 'State of New Mexico',
        state: 'NM',
      },

      company: {
        companyId: 0,
        companyName: 'Globe Life',
      },
    }
  },
  methods: {
    showStartMsg() {
      this.startMsg = true
    },
    routeHome() {
      return this.$router.push('/')
    },
    showVideo() {
      let width = window.innerWidth - 200
      window.open(
        './ProductPresentation.mp4',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,left=100,width=' +
          width +
          ',height=1000'
      )
    },
  },
}
</script>

<style>
html {
  background-color: aliceblue;
}
.content {
  padding-top: 25px;
  margin-bottom: 100px;
}
.waitFont {
  color: lightslategray;
}
.waitCard {
  background-color: #04325f;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.navDrawer {
  text-decoration: none;
}
#content {
  padding-top: 50px;
}
.footerText {
  text-align: center;
  color: white;
}
.logo {
  cursor: pointer;
}
.logoSm {
  cursor: pointer;
}
.navDrawer {
  font-weight: normal;
  font-size: 14px;
}
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
  background-color: #00558c !important;
  border-color: #00558c !important;
}
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: rgba(0, 0, 0, 0.38) !important;
}
@media screen and (-ms-high-contrast: active),
  screen and (-ms-high-contrast: none) {
  .v-btn::before {
    border-radius: 1.5pt !important;
  }
}
table.v-table thead th {
  transition: ease !important;
  -webkit-transition: ease !important;
}
table.v-table tbody tr {
  transition: ease !important;
  -webkit-transition: ease !important;
}
table.table thead th {
  transition: ease !important;
  -webkit-transition: ease !important;
}
table.table tbody tr {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-input--selection-controls__ripple {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-input--selection-controls__input {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-input__slot {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-datatable__expand-content {
  transition: ease !important;
  -webkit-transition: ease !important;
}

.v-input__slot {
  transition: ease !important;
  -webkit-transition: ease !important;
}
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-icon material-icons theme--light {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-label {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-slider__track,
.v-slider__track-fill {
  transition: ease !important;
  -webkit-transition: ease !important;
}
.v-slider__thumb-container {
  transition: ease !important;
  -webkit-transition: ease !important;
}
#logo > div.v-image__image.v-image__image--contain {
  background-position-x: left !important;
}
.material-icons {
  -webkit-font-feature-settings: 'liga';
  -moz-font-feature-settings: 'liga';
  font-feature-settings: 'liga';
}
.v-table__overflow {
  position: relative;
}
</style>
